import { Model } from '@/models/Model';
import client from "@/support/Client";

export class Payment extends Model {
  protected $name: string = 'Payment';
  protected $endpoint: string = '/payments';
  protected $fillable: string[] = [
    'lead',
  ];

  public lead?: string;
  public payments?: PaymentMethod[];
}

export interface PaymentMethod {
  id?: string;
  title?: string;
  image?: Image[];
  active?: boolean;
  issuers?: PaymentMethod[];
}

interface Image {
  size1x?: string;
  size2x?: string;
  svg?: string;
}
